import { Component, Input, OnInit, inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AppComponent } from 'app/app.component';
import { XpressUserProfile } from 'app/models';
import { AppDataService, MenuService } from 'app/services';
import { navigationMenuTestId } from 'app/layout/menuitem/navigation-menu-testid';

@Component({
  selector: 'menuitem-partners',
  standalone: false,
  templateUrl: './menuitem-partners.component.html',
  styleUrls: ['./menuitem-partners.component.scss',
    '../../../../styles/m3-defaul-material-theme.scss'
  ]
})
export class MenuitemPartnersComponent implements OnInit {
  public _profile = new XpressUserProfile();

  @Input() menuItems: any[] = [];
  @Input()
  set profile(value: XpressUserProfile) {
    // eslint-disable-next-line no-underscore-dangle
    this._profile = value; // example transformation
  }

  constructor(
    public app: AppComponent,
    public appData: AppDataService,
    private menuService: MenuService,
  ){}

  public readonly navigationMenuTestId = navigationMenuTestId;
  public activeLink: string = 'home';
  public navIndex: number = 0;
  public isSubMenuActive: boolean = false;
  public activeSubLink: string = 'dashboard';
  public activeChildLink: string = '';
  active = false;
  public subMenuItem: any;
  isExpanded = false;
  isSideMenu = false;
  private renderer = inject(Renderer2);
  private document: Document = inject(DOCUMENT);

  ngOnInit(): void {
  }

  navClick(isActive: string, index: number) {
    this.navIndex = index;
    this.activeLink = isActive;
    this.isSubMenuActive = true;
  }

  subClick(item: any, event: Event) {
    // this.isSubMenuActive = false;
    this.activeLink = item.activeMenu;

    if (item.disabled) {
        event.preventDefault();
        return;
    }

    // navigate with hover in horizontal mode
    if (item.root) {
        this.app.menuHoverActive = !this.app.menuHoverActive;
    }

    // execute command
    if (item.command) {
       item.command({ originalEvent: event, item });
    }

    // toggle active state
    if (item.items) {
        this.active = !this.active;
    } else {
        // activate item
        this.active = true;

        // reset horizontal menu
        if (this.app.isSlim() || this.app.isHorizontal()) {
            this.menuService.reset();
        }

        this.app.staticMenuMobileActive = false;
        this.app.menuHoverActive = !this.app.menuHoverActive;

        this.app.unblockBodyScroll();
    }

      if (item.menuFlag) {
        sessionStorage.setItem('currentMenuItem', JSON.stringify(item));
        this.app.goToMenuRoute(item);
    }
  }

  toggleSidebar() {
    this.isExpanded = !this.isExpanded;
    this.isSideMenu = !this.isSideMenu;
      if (this.isSideMenu) {
      this.renderer.setStyle(this.document.documentElement, '--b-width', '90%');
      this.renderer.setStyle(this.document.documentElement, '--b-margin-left', '13%');
      this.renderer.addClass(this.document.body, 'side-menu-open');
    } else {
      this.renderer.setStyle(this.document.documentElement, '--b-width', '100%');
      this.renderer.setStyle(this.document.documentElement, '--b-margin-left', '2%');
      this.renderer.removeClass(this.document.body, 'side-menu-open');
    }
  }

  public logout(): boolean {
    this.appData.logout();
    return false;
  }
}
